var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 575,
    viewBox: "0 0 455 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M88.5307 156.02C91.5997 147.855 102.616 146.255 107.707 153.235L176.805 247.979C181.59 254.541 177.495 263.882 169.312 265.07L58.5532 281.156C50.3695 282.345 43.9845 274.526 46.8699 266.85L88.5307 156.02Z",
    fill: "#138CE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.761 463.998C6.64007 464.857 0.787819 455.132 5.57438 447.07L70.5495 337.642C75.0497 330.063 85.712 329.635 90.0593 336.859L148.896 434.631C153.243 441.855 148.148 451.534 139.573 452.342L15.761 463.998Z",
    fill: "#138CE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M316.996 510.839C307.355 516.943 294.812 509.786 295.162 498.382L299.917 343.567C300.246 332.844 311.872 326.329 321.189 331.645L447.294 403.598C456.612 408.915 456.918 422.238 447.855 427.977L316.996 510.839Z",
    fill: "#138CE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M340.137 298.827C333.382 303.105 324.592 298.09 324.837 290.098L328.169 181.609C328.4 174.095 336.547 169.53 343.076 173.255L431.446 223.677C437.975 227.403 438.19 236.739 431.838 240.761L340.137 298.827Z",
    fill: "#138CE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.93137 152.42C1.93798 152.222 -2.58264 143.168 2.06265 136.66L65.1202 48.3164C69.4875 42.1977 78.7977 42.9293 82.1558 49.655L127.605 140.682C130.963 147.408 125.953 155.289 118.438 155.103L9.93137 152.42Z",
    fill: "#138CE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M333.454 161.443C327.67 166.963 318.067 163.771 316.739 155.886L298.708 48.855C297.459 41.442 304.551 35.366 311.685 37.7373L408.233 69.8298C415.367 72.201 417.41 81.3136 411.972 86.5039L333.454 161.443Z",
    fill: "#138CE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M41.3984 298.506C38.2045 301.148 33.0057 299.468 32.3493 295.581L23.4386 242.819C22.8214 239.165 26.7317 236.266 30.5935 237.514L82.8599 254.41C86.7217 255.658 87.7569 260.156 84.7541 262.64L41.3984 298.506Z",
    fill: "#138CE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M318.711 163.748C315.349 161.324 315.664 155.869 319.26 154.254L368.071 132.33C371.452 130.812 375.243 133.865 375.009 137.916L371.835 192.754C371.601 196.806 367.509 198.941 364.348 196.662L318.711 163.748Z",
    fill: "#138CE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M335.748 373.513C329.945 371.604 327.959 363.801 332.291 359.93L391.097 307.392C395.17 303.754 401.856 306.354 403.332 312.15L423.297 390.601C424.772 396.397 419.975 401.22 414.519 399.425L335.748 373.513Z",
    fill: "#138CE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangles);
export default __webpack_public_path__ + "static/media/triangles.ba39396e7511852807a5216a780b6dcf.svg";
export { ForwardRef as ReactComponent };